<section class="login">
  <i-authentication
    [integration]="'component'"
    [applicationName]="'iCourrier Web'"
    [logoUrl]="'assets/img/iCourrer_Icon_1024.png'"
    [subtitle]="'Connexion à iCourrier Web'"
    [description]="'Pour des questions de sécurité, vous allez être redirigé vers notre plateforme d\'authentification afin de vous connecter à l\'application.'"
    (onLogin)="login()"/>

  <p class="login__assistance">
    Assistance Inforius - <a href="tel:081744340">081/744 340</a> - <a href="mailto:infodoc@inforius.be">infodoc&#64;inforius.be</a>
  </p>
</section>
